import $ from 'jquery';
import accordionMinusGreyUrl from '@/images/accordion-minus-grey.png';
import accordionPlusGreyUrl from '@/images/accordion-plus-grey.png';
import ajaxHttpHeaders from '@/lib/ajaxHttpHeaders';
import appConfig from '@/lib/appConfig';
import initDataTables from 'datatables.net';
import manualPrintPreview from '@/lib/manualPrintPreview';
import npPassengerVanShuttleBusUrl from '@/images/np_passenger_van_shuttle_bus.png';
import npPickupUrl from '@/images/np_pickup.png';
import npRefuseUrl from '@/images/np_refuse.png';
import npSchoolBusUrl from '@/images/np_school_bus.png';
import npSedanWagonUrl from '@/images/np_sedan_wagon.png';
import npStepVanUrl from '@/images/np_step_van.png';
import npStreetSweeperUrl from '@/images/np_street_sweeper.png';
import npSuvUrl from '@/images/np_suv.png';
import npTractorUrl from '@/images/np_tractor.png';
import npTransitBusUrl from '@/images/np_transit_bus.png';
import npVanUrl from '@/images/np_van.png';
import npVocationalCabChassisUrl from '@/images/np_vocational_cab_chassis.png';
import populateFuels from '@/lib/populateFuels';
import urlParam from '@/lib/urlParam';
import vehicleNotPicturedUrl from '@/images/vehicle_not_pictured.png';
import whiteMinusUrl from '@/images/white_minus.png';
import whitePlusUrl from '@/images/white_plus.png';

initDataTables(window, $);

var compare_id_list = [];
var MAX_NUMBER_COMPARE_LIST_ITEMS = 4;

function results_params() {
  // Build param list for a URL
  var str = "view_mode="+$('#view_mode').val()+"&search_field="+$('#search_field').val()+"&search_dir="+$('#search_dir').val()+"&per_page="+$("#per_page").val()+"&current=true&display_length="+$("select[name='list_table_length']").val();

  // Collect model years
  var model_year_ids = [];
  $('input[name="model_year_ids[]"]:checked').each(function() {
    model_year_ids.push(this.value);
  });
  if (model_year_ids.length == 0) {
    str += "&model_year=0";
  } else {
    str += "&model_year=" + model_year_ids.join(',');
  }

  // Collect all the fuels
  var all_fuels_checked = $('#all_fuels:checked').length ? $('#all_fuels').val() : '';
  if (all_fuels_checked == '') {
    var fuel_ids = '';
    $('input[name="fuel_ids[]"]:checked').each(function() {
      fuel_ids += this.value+ ',';
    });
    str += "&fuel_id=" + fuel_ids + "-1";
  } else str += '&all_fuels=y';

  // Collect all the categories
  var all_categories_checked = $('#all_categories:checked').length ? $('#all_categories').val() : '';
  if (all_categories_checked == '') {
    var category_ids = '';
    $('input[name="category_ids[]"]:checked').each(function() {
      category_ids += this.value+ ',';
    });
    str += "&category_id=" + category_ids + "-1";
  } else str += '&all_categories=y';

  // Collect all the manufacturers
  var all_manufacturers_checked = $('#all_manufacturers:checked').length ? $('#all_manufacturers').val() : '';
  if (all_manufacturers_checked == '') {
    var manufacturer_ids = '';
    $('input[name="ld_manufacturer_ids[]"]:checked').each(function() {
      manufacturer_ids += this.value+ ',';
    });
    $('input[name="hd_manufacturer_ids[]"]:checked').each(function() {
      manufacturer_ids += this.value+ ',';
    });
    str += "&manufacturer_id=" + manufacturer_ids + "-1";
  }  else str += '&all_manufacturers=y';
  return str;
}

function ajax_url() {
  return `${appConfig.api_url_root}/v1/vehicles.json?current=true&${results_params()}`;
}

function update_results() {
  // Update browser url (not I.E. compatable)
  var params = results_params();
  var delay = 750;
  history.replaceState({}, "", "?" + params);
  // Update the search results
  var url = "/vehicles/search/results?" + params;
  var csv_url = "/vehicles/search/results.csv?" + params;
  start_ajax_spinner();
  $("#vehicles_csv_download").prop('href', csv_url);

  // update grid_view
  window.gridUrl = url

  // update list view.
  window.ajaxUrl = ajax_url();
  window.ajaxSendTime = Date.now()+delay;
  window.setTimeout(function(){delayed_update_results()}, delay);
}

function delayed_update_results() {
  if (Date.now() >= window.ajaxSendTime) {
    if (window.ajaxGet) {
      window.ajaxGet.abort();
    }
    if (window.datatableAjax) {
      window.datatableAjax.abort();
    }

    window.trackPageview(window.gridUrl);
    window.ajaxGet =  $.ajax({url: window.gridUrl, dataType: "script", cache: true});
    $('#list_table').dataTable().api().ajax.url( window.ajaxUrl ).load();
  }
}

window.pagination_client_side_load = function() {
  $(".afdc_pagination .pagination a").on("click", function() {
    var url = "/vehicles/search/results?"+this.href.split("?")[1]
    url = url.replace("#", "").replace("&view_mode=list", '').replace("view_mode=list", '');
    $.ajax({url: url, cache: true, dataType: "script"});
    $('html, body').animate({ scrollTop: $(".results-line").offset().top }, 100);
    start_ajax_spinner();
    return false
  });
}

window.pagination_update_per_page = function() {
  $(".per_page").on("change", function() {
    var url = "/vehicles/search/results?"+results_params()+"&per_page="+$(this).val()
    $.ajax({url: url, cache: true, dataType: "script"});
    start_ajax_spinner();
    return false
  });
}

function start_ajax_spinner() {
  $("#box_view").html('');
  $("#result_spinner").show();
  $("#list_table_wrapper").hide();
  $(".compare").hide();
}

function hide_zero_results() {
  $("#result_count_0").hide();
  toggle_list_box_view();
}

function show_zero_results() {
  $("#result_count_0").show();
  $('#box_view').hide();
  $('#list_view').hide();
}

window.calculate_vehicle_page_count = function() {
  var view_mode = $("#view_mode").val();
  var total = parseInt($("#vehicle_count").val());
  var page_size = parseInt($(".per_page").val());
  var page = parseInt($(".afdc_pagination .pagination .current").text());
  if (view_mode == 'grid') {
    if ($(".per_page").val() == 'all') {page_size = total;}
    if (isNaN(page)){ page = 1 }
    if (!(isNaN(page_size))) {$("#per_page").val(page_size);}
  } else {
    page_size = parseInt($("select[name='list_table_length']").val());
    page = parseInt($("#list_table_paginate .active").text());
  }
  if (total == 0) {
    $(".num-vehicles").text(total+" vehicles");
  } else {
    var start = ((page-1)*page_size)+1;
    var end = (start+page_size) - 1;
    if ( end > total ) { end = total; }
    if (!(isNaN(start) || isNaN(end))) {
      $(".num-vehicles").text(start+" - "+end+" of "+total+" vehicles");
    }
  }
};

function toggle_list_box_view() {
  if ($('#view_mode').val() == 'list') {
    $('#box_view').hide();
    $('#list_view').show();
    $('#list_table').css('width','');
    $('#box_view_link').css('background-color', '');
    $('#list_view_link').css('background-color', '#eee');
    $('#view_mode').val('list');
  } else {
    $('#box_view').show();
    $('#list_view').hide();
    $('#box_view_link').css('background-color', '#eee');
    $('#list_view_link').css('background-color', '');
    $('#view_mode').val('grid');
  }
  window.calculate_vehicle_page_count();
  $('#box_view_link').click(function(e) {
    e.defaultPrevented;
    $('#box_view').show();
    $('#list_view').hide();
    $('#box_view_link').css('background-color', '#eee');
    $('#list_view_link').css('background-color', '');
    $('#view_mode').val('grid');
    window.calculate_vehicle_page_count();
  });
  $('#list_view_link').click(function(e) {
    e.defaultPrevented;
    $('#box_view').hide();
    $('#list_view').show();
    $('#list_table').css('width', '');
    $('#box_view_link').css('background-color', '');
    $('#list_view_link').css('background-color', '#eee');
    $('#view_mode').val('list');
    // update result line
    window.calculate_vehicle_page_count();
  });
}

function toggle_results_view() {
  if ($("#vehicle_count").val() == '0') {
    show_zero_results();
  } else {
    hide_zero_results();
  }
}

window.remove_compare_item = function(id) {
  $('#close_'+id).parent().remove();
  var index = compare_id_list.indexOf(id.toString());
  if (index > -1 ) {compare_id_list.splice(index, 1);}
  $('input[name="compare_ids[]"][value='+id+']', $('#list_table').dataTable().fnGetNodes()).prop('checked', false);
  if (compare_id_list.length == 0) {
    $('#compare_block').css('display', 'none');
  }
};

function populate_model_years() {
  var checked_model_years = [];
  $("#model_year_search input[name='model_year_ids[]']:checked").each(function() {
    checked_model_years.push(this.value);
  });

  if (checked_model_years.length == 0) {
    $("#model_year").html("None");
  } else {
    $("#model_year").html(checked_model_years.join(", "));
  }
}

function populate_manufacturers() {
  var ld_mans_checked = $("#ld_manufacturer_search input[name='ld_manufacturer_ids[]']:checked");
  var hd_mans_checked = $("#hd_manufacturer_search input[name='hd_manufacturer_ids[]']:checked");
  var ld_mans = $("#ld_manufacturer_search input[name='ld_manufacturer_ids[]']");
  var hd_mans = $("#hd_manufacturer_search input[name='hd_manufacturer_ids[]']");
  // check for all checked
  if (ld_mans_checked.length == ld_mans.length && hd_mans_checked.length == hd_mans.length) {
    $("#manufacturer_name").html("All");
  } else if (ld_mans_checked.length == 0 && hd_mans_checked.length == 0) {
    $("#manufacturer_name").html("None");
  } else {
    var mans = [];
    var index = 0;
    if (ld_mans_checked.length == ld_mans.length) {
      mans[index] = "All light-duty";
    } else {
      $.each( ld_mans_checked, function(num, elem) {
        try {
          mans[num] = $(elem).parent().parent().find(".facet_label").text().trim();
        } catch (e) {
          mans[num] = $(elem).parent().parent().find(".facet_label").text();
        }
        index = num;
      });
    }
    if (ld_mans_checked.length != 0) {index++;}
    if (hd_mans_checked.length == hd_mans.length) {
      mans[index] = "All medium- and heavy-duty";
    } else {
      $.each( hd_mans_checked, function(num, elem) {
        try {
          mans[index+num] = $(elem).parent().parent().find(".facet_label").text().trim();
        } catch (e) {
          mans[index+num] = $(elem).parent().parent().find(".facet_label").text();
        }
      });
    }
    $("#manufacturer_name").html(mans.join(", "));
  }
}

function populate_categories() {
  var checked_categories = $("#category_search input[name='category_ids[]']:checked");
  if( checked_categories.length == $("#category_search input[name='category_ids[]']").length ){
    $("#category_name").html("All");
  } else if ( checked_categories.length == 0 ) {
    $("#category_name").html("None");
  } else {
    var categories = [];
    $.each( checked_categories, function(num, elem) {
      // FIXME: IE 8 compatability
      try {
        categories[num] = $(elem).parent().parent().find(".facet_label").text().trim();
      } catch(e) {
        categories[num] = $(elem).parent().parent().find(".facet_label").text().text();
      }
    });
    $("#category_name").html(categories.join(", "));
  }
}

function print_all() {
  if ($("#view_mode").val() == 'grid'){
    $(".per_page").val('all');
    $(".per_page").trigger('change');
  } else {
    $('#list_table').dataTable().fnSettings()._iDisplayLength = -1;
    $('#list_table').dataTable().fnDraw();
  }
  //trigger print preview screen WHY WONT YOU WORK?!?! :'(
  manualPrintPreview();

  //reset the results when print preview is closed
  $("#print_preview_cancel").on('click', function(){
    if ($("#view_mode").val() == 'grid'){
      $(".per_page").val($("#per_page").val());
      $(".per_page").trigger('change');
    } else {
      $('#list_table').dataTable().fnSettings()._iDisplayLength = 25;
      $('#list_table').dataTable().fnDraw();
    }
  });
}

$(document).ready(function() {
  $("#print_all").on("click", print_all);
  $("#print_preview_print").on("mousedown", function(){$(".modal").addClass("hidden-print");});
  $("#print_preview_cancel").on("mousedown", function(){$(".modal").removeClass("hidden-print");});

  if (urlParam('ids')) {
    compare_id_list = urlParam('ids').split(",");
  }
  toggle_results_view();

  $('#all_fuels').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="fuel_ids[]"]').prop('checked', true);
    } else {
      $('input[name="fuel_ids[]"]').prop('checked', false);
    }
  });
  $('#all_categories').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="category_ids[]"]').prop('checked', true);
    } else {
      $('input[name="category_ids[]"]').prop('checked', false);
    }
  });
  $('#all_ld_manufacturers').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="ld_manufacturer_ids[]"]').prop('checked', true);
    } else {
      $('input[name="ld_manufacturer_ids[]"]').prop('checked', false);
    }
  });
  $('#all_hd_manufacturers').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="hd_manufacturer_ids[]"]').prop('checked', true);
    } else {
      $('input[name="hd_manufacturer_ids[]"]').prop('checked', false);
    }
  });
  $('.update_results_button').click(function() {
    update_results();
  });

  // set "all" filters
  if ($("#ld_manufacturer_search .fuel-select").length == $("#ld_manufacturer_search .fuel-select input:checked").length) {
    $('#all_ld_manufacturers').prop('checked', true);
  } else {
    $('#all_ld_manufacturers').prop('checked', false);
  }
  if ($("#hd_manufacturer_search .fuel-select").length == $("#hd_manufacturer_search .fuel-select input:checked").length) {
    $('#all_hd_manufacturers').prop('checked', true);
  } else {
    $('#all_hd_manufacturers').prop('checked', false);
  }
  if ($("#category_search .fuel-select").length == $("#category_search .fuel-select input:checked").length) {
    $('#all_categories').prop('checked', true);
  } else {
    $('#all_categories').prop('checked', false);
  }
  if ($("#fuel_tech_search .fuel-select").length == $("#fuel_tech_search .fuel-select input:checked").length) {
    $("#all_fuels").prop('checked', true);
  } else {
    $("#all_fuels").prop('checked', false);
  }

  // show/hide light duty emission info link
  // the link should only display if there are light-duty vehicles in the results
  // these are the ids of the vehicle categories related to light-duty vehicles
  // Sedan/Wagon, SUV, Vocational/Cab Chassis, Van, Pickup
  var ld_category_ids = [27, 29, 17, 9, 25]
  var ld_manufacturers_count = $('#ld_manufacturer_search .fuel-select input:checked').get().length
  var ld_vehicle_categories_count = $('#category_search .fuel-select input:checked')
    .get()
    .map(function(a) {
      return parseInt(a.value)
    }).filter(function(a) {
      return ld_category_ids.indexOf(a) >= 0
    }).length

  if ((ld_manufacturers_count > 0) && (ld_vehicle_categories_count > 0)) {
    $('.ld_emission_info').show()
  } else {
    $('.ld_emission_info').hide()
  }

  $('.facet').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).attr('id') == 'ld_manufacturer_ids_') {
      if ($("#ld_manufacturer_search .fuel-select").length == $("#ld_manufacturer_search .fuel-select input:checked").length) {
        $('#all_ld_manufacturers').prop('checked', true);
      } else {
        $('#all_ld_manufacturers').prop('checked', false);
      }
    }
    if ($(this).attr('id') == 'hd_manufacturer_ids_') {
      if ($("#hd_manufacturer_search .fuel-select").length == $("#hd_manufacturer_search .fuel-select input:checked").length) {
        $('#all_hd_manufacturers').prop('checked', true);
      } else {
        $('#all_hd_manufacturers').prop('checked', false);
      }
    }
    if ($(this).attr('id') == 'category_ids_') {
      if ($("#category_search .fuel-select").length == $("#category_search .fuel-select input:checked").length) {
        $('#all_categories').prop('checked', true);
      } else {
        $('#all_categories').prop('checked', false);
      }
    }
    if ($(this).attr('id') == 'fuel_ids_') {
      if ($("#fuel_tech_search .fuel-select").length == $("#fuel_tech_search .fuel-select input:checked").length) {
        $("#all_fuels").prop('checked', true);
      } else {
        $("#all_fuels").prop('checked', false);
      }
    }
    update_results();
  });

  $('.accordion-header').click(function() {
    var this_img = $(this).find('img');
    if (this_img.attr('src') == whiteMinusUrl) {
      this_img.attr('src', whitePlusUrl);
    } else {
      this_img.attr('src', whiteMinusUrl);
    }
  });
  $('.compare_button').click(function() {
    if (compare_id_list.length > MAX_NUMBER_COMPARE_LIST_ITEMS) {
      alert('You may only select ' + MAX_NUMBER_COMPARE_LIST_ITEMS + ' vehicles to compare.');
      return false;
    } else if (compare_id_list.length > 0) {
      $(this).attr("cursor", "pointer");
      // Collect all the vehicle ids
      var ids = compare_id_list.join(',');

      window.location.href = "/vehicles/search/compare?"+results_params()+"&ids="+ids+"&page_type=vehicle";
    }
  });

  var display_length = parseInt($("#display_length").val());

  $('#list_table').dataTable( {
    "ajax": {
      "cache": "true",
      "dataType": 'JSON',
      "url": ajax_url(),
      "headers": ajaxHttpHeaders(),
      "dataSrc": function ( json ) {

        // if ( json['inputs']['ajax_count'] != window.ajaxCount ) {
        //   return false;
        // } else {
        var items = [];
        var no_image_hash = {};
        no_image_hash["np_refuse.png"] = npRefuseUrl;
        no_image_hash["np_school_bus.png"] = npSchoolBusUrl;
        no_image_hash["np_sedan_wagon.png"] = npSedanWagonUrl;
        no_image_hash["np_passenger_van_shuttle_bus.png"] = npPassengerVanShuttleBusUrl;
        no_image_hash["np_step_van.png"] = npStepVanUrl;
        no_image_hash["np_street_sweeper.png"] = npStreetSweeperUrl;
        no_image_hash["np_suv.png"] = npSuvUrl;
        no_image_hash["np_tractor.png"] = npTractorUrl;
        no_image_hash["np_transit_bus.png"] = npTransitBusUrl;
        no_image_hash["np_pickup.png"] = npPickupUrl;
        no_image_hash["np_van.png"] = npVanUrl;
        no_image_hash["np_vocational_cab_chassis.png"] = npVocationalCabChassisUrl;
        no_image_hash["vehicle_not_pictured.png"] = vehicleNotPicturedUrl;
        $.each( json['result'], function( num, obj ) {
          // Name
          var name = obj['manufacturer_name'] + ' ' + obj['model'] + ' ' + obj['model_year'];
          if (obj['heavy_duty_manufacturer_name'] && obj['heavy_duty_manufacturer_name'] != '') {
            name = obj['heavy_duty_manufacturer_name'] + ' ' + obj['model'];

            if (obj['heavy_duty_weight_class']) {
              name = name + ' - ' + obj['heavy_duty_weight_class']['name'];
            }
          }

          // Fuel
          var fuel_name = '';
          if (obj['fuel_name'])
            fuel_name = obj['fuel_name'];
          if (obj['fuels'] && Array.isArray(obj['fuels'])) {
            $.each(obj['fuels'], function(num, fuelarr) {
              if (fuel_name != '') fuel_name += ' | ';
              fuel_name += fuelarr['name'];
            });
          }
          var fuel_name_row_after = fuel_name;
          if (obj['phev_type']) {
            fuel_name_row_after += ' (<a href="/glossary.html#PHEVConfiguration" class="glossary">' +  (obj['phev_type'] === 'Blended' ? 'Parallel' : 'Series') + '</a>)';
          }

          // Transmission types
          var transmission_type = '';
          if (obj['transmission_make'] != '' && obj['transmission_make'] != null) {
            transmission_type = obj['transmission_make'] + ' ';
          }
          if (obj['heavy_duty_transmission_types'] && Array.isArray(obj['heavy_duty_transmission_types'])) {
            $.each(obj['heavy_duty_transmission_types'], function(num, tt) {
              if (transmission_type != '') transmission_type += '/';
              transmission_type += tt['name'];
            });
          }
          // Emissions Certifications
          var emissions_cert = '';
          if (obj['heavy_duty_emission_certifications'] && Array.isArray(obj['heavy_duty_emission_certifications'])) {
            $.each(obj['heavy_duty_emission_certifications'], function(num, tt) {
              if (emissions_cert != '') emissions_cert += ', ';
              emissions_cert += tt['name'];
            });
          }
          // Category
          var category_name = '';
          if (obj['category_name'] != '' && obj['category_name'] != null) category_name = obj['category_name'];

          // builds fuel economy info for results table data and details row
          var fuel_econ_obj = {
            altCity: obj['alternative_fuel_economy_city'],
            altHwy: obj['alternative_fuel_economy_highway'],
            convCity: obj['conventional_fuel_economy_city'],
            convHwy: obj['conventional_fuel_economy_highway'],
            altComb: obj['alternative_fuel_economy_combined'],
            convComb: obj['conventional_fuel_economy_combined'],
            phevType: function(fuelEconType) {
              if (obj['phev_type'] && fuelEconType === 'alt') {
                if (obj['phev_type'] === 'Blended') {
                  return ' - Gas and Electric:'
                } else {
                  return ' - Electric Only:'
                }
              } else {
                return ':'
              }
            },
            determineFuelEconomyUnit: function(fuelCode) {
              var mpgTypes = ['E85_GSLN', 'BD', 'HYBR']
              if (mpgTypes.indexOf(fuelCode) > -1 || fuelCode === 'mpg') {
                return 'mpg'
              } else {
                return 'MPGe'
              }
            },
            detailsInfo: function(fuelEconType) {
              var fuelUnit = this.determineFuelEconomyUnit(obj['fuel_code'])
              var econType = 'Alternative'

              if (fuelEconType !== 'alt') {
                econType = 'Conventional'
                fuelUnit = 'mpg'
              }

              var detailString = '<strong>' + econType + ' Fuel Economy (Combined)' + this.phevType(fuelEconType) + '</strong> '

              var mpgInfo = '';

              if (this[fuelEconType + 'Comb']) {
                mpgInfo += this[fuelEconType + 'Comb'] + ' ' + fuelUnit;
              }

              if (obj['fuel_economy_estimated_by_manufacturer'] === true) {
                mpgInfo += '<div class="estimated">estimated</div>';
              }

              mpgInfo == '' ? detailString = '' : detailString += mpgInfo + '<br>';

              return detailString;
            },
            fuelsInfoForDetailsRow: function() {
              var alternative = this.detailsInfo('alt')
              var conventional = this.detailsInfo('conv')
              if (this.altCity || this.altHwy || this.convCity || this.convHwy || this.altComb || this.convComb) {
                return alternative + conventional
              } else {
                return ''
              }
            },
            listInfo: function(fuelEconType, label) {
              var fuelUnit = this.determineFuelEconomyUnit(fuelEconType === 'conv' ? 'mpg' : obj['fuel_code'])
              return this[fuelEconType + 'Comb'] + ' ' + fuelUnit + ' ' + label
            },
            fuelsInfoForListTable: function() {
              if (this.altComb && this.convComb) {
                return this.listInfo('alt', 'alternative') + ' | ' + this.listInfo('conv', 'conventional')
              } else if (this.altComb) {
                return this.listInfo('alt', 'combined')
              } else if (this.convComb) {
                return this.listInfo('conv', 'combined')
              } else {
                return ''
              }
            },
          }

          // Fuel Economy for list table
          var fuel_econ = '<i>no data</i>';
          if (obj['class'] === 'LightDutyAutomobile') fuel_econ = fuel_econ_obj.fuelsInfoForListTable()

          var chked = '';

          if ($.inArray((obj['class'] + "_" + obj['id']).toString(), compare_id_list) >= 0) {
            chked = 'checked';
            $('#compare_block').css('display', 'block');
            $('#compare_block').css('height', 'auto');
            $('#compare_list').html($('#compare_list').html() + "<div class='item_box'><span style='float:left;'>"+name+"&nbsp;</span><a href='javascript:window.remove_compare_item(\""+obj['class'] + "_" + obj['id']+"\");' id='close_"+obj['class'] + "_" + obj['id']+"' class='close_x'>X</a></div>");
          }
          var compare = '<input type="checkbox" id="compare_ids_" name="compare_ids[]" data-name="'+name+'" value="' + obj['class'] + "_" + obj['id'] + '" ' + chked + '>';
          // Detail row
          var row_after = '<h3>' + name + '</h3> \
              <div class="row-fluid list_accordion_detail" style="">';

          var cn = '';
          if (category_name != '') {
            cn = category_name;
          } else {
            if (obj['vehicle_categories'].length != 0) {
              cn = obj["vehicle_categories"][0]['name'];
            }
          }
          var category_display_name = category_name === 'SUV' ? 'SUV' : category_name.toLowerCase();
          cn = cn.toLowerCase().replace(/[^\w]+/g, '_');
          var no_image = "vehicle_not_pictured.png";
          if (cn != '') no_image = "np_"+cn+".png";
          var no_image_tag = no_image_hash[no_image];
          if (obj['photo_url'] != '' && obj['photo_url'] != null) {
            row_after += '<div class="span5"><img class="vehicle_image lazy" data-src="'+obj['photo_url']+'" src="'+no_image_tag+'"></div>';
          }  else  {
            row_after += "<div class='span5'><img src='"+no_image_tag+"', class=\"vehicle_image\") %></div>";
          }

          row_after += '<div class="span6">'+fuel_name_row_after+'<br>'+category_display_name;

          if (obj['seating_capacity'] > 0) {
            row_after += '<br>' + obj['seating_capacity'] + ' seats';
          }

          if (obj['base_msrp'] > 0) {
            row_after += '<br>$' + obj['base_msrp'].toLocaleString() + ' base MSRP';
          }

          row_after += '</div><div class="span13">';

          // Fuel Economy for details row
          row_after += fuel_econ_obj.fuelsInfoForDetailsRow()

          if (obj['electric_range']) {
            row_after += '<strong>Electric-Only Range:</strong> ' + obj['electric_range'] + ' miles<br>'
          }

          if (obj['total_range']) {
            row_after += '<strong>Total Range:</strong> ' + obj['total_range'] + ' miles<br>'
          }

          if (obj['charging_rate_level_2'] !== null || obj['charging_rate_dc_fast'] !== null) {
            row_after += '<strong>Charging Rate:</strong><br><li>';

            if (obj['charging_rate_level_2'] !== null) {
              row_after += '<i>Level 2:</i> ' + obj['charging_rate_level_2'] + ' kW';
            }

            if (obj['charging_rate_level_2'] !== null && obj['charging_rate_dc_fast'] !== null) {
              row_after += ' | ';
            }

            if (obj['charging_rate_dc_fast'] !== null) {
              row_after += '<i>DC Fast:</i> ' + obj['charging_rate_dc_fast'] + ' kW';
            }

            row_after += '</li>';
          }


          if (obj['charging_speed_level_1'] !== null || obj['charging_speed_level_2'] !== null || obj['charging_speed_dc_fast'] !== null) {
            row_after += '<strong>Charging Speed (per hour of charging):</strong><li>';

            if (obj['charging_speed_level_1'] !== null) {
              row_after += '<i>Level 1:</i> ' + obj['charging_speed_level_1'] + ' miles';
            }

            if ((obj['charging_speed_level_1'] !== null && obj['charging_speed_level_2'] !== null) || (obj['charging_speed_level_1'] !== null && obj['charging_speed_level_2'] === null && obj['charging_speed_dc_fast'] !== null)) {
              row_after += ' | ';
            }

            if (obj['charging_speed_level_2'] !== null) {
              row_after += '<i>Level 2:</i> ' + obj['charging_speed_level_2'] + ' miles';
            }

            if (obj['charging_speed_level_2'] !== null && obj['charging_speed_dc_fast'] !== null) {
              row_after += ' | ';
            }

            if (obj['charging_speed_dc_fast'] !== null) {
              row_after += '<i>DC Fast:</i> ' + obj['charging_speed_dc_fast'] + ' miles';
            }

            row_after += '</li>';
          }

          if (obj['battery_capacity_kwh'] > 0) {
            row_after += '<strong>Battery Capacity:</strong> ' + obj['battery_capacity_kwh'] + ' kWh<br>';
          }

          if (emissions_cert != '') {
            row_after += '<strong>Emission Certification:</strong> '+emissions_cert+'<br>';
          }

          if (obj['num_passengers'] != '' && obj['num_passengers'] != null) {
            row_after += '<strong>Maximum Seating:</strong> '+obj['num_passengers']+'<br>';
          }

          if (obj['engine_description'] != '' && obj['engine_description'] != null) {
            row_after += '<strong>Engine/Motor(s):</strong> '+obj['engine_description']+'<br>';
          }

          if (transmission_type != '') {
            row_after += '<strong>Transmission:</strong> '+transmission_type+'<br>';
          }

          if (obj['drivetrain'] && obj['drivetrain'] != '') {
            row_after += '<strong>Drivetrain:</strong> ' + obj['drivetrain'] + '<br>';
          }

          if (obj['heavy_duty_engines'] != null && obj['heavy_duty_engines'].length > 0) {
            row_after += '<strong>Power Source(s):</strong><br>';
            $.each(obj['heavy_duty_engines'], function(num, vehicle) {
              row_after += '<li>'+vehicle['heavy_duty_manufacturer_name']+ ' '+vehicle['model']+'</li>';
            });
          }

          if (obj['heavy_duty_hybrids'] != null && obj['heavy_duty_hybrids'].length > 0) {
            row_after += '<strong>Hybrid System(s):</strong><br>';
            $.each(obj['heavy_duty_hybrids'], function(num, vehicle) {
              row_after += '<li>'+vehicle['heavy_duty_manufacturer_name']+ ' '+vehicle['model']+'</li>';
            });
          }

          if (obj['notes']) {
            row_after += '<div class="notes_box"><strong>Note:</strong> ' + obj['notes'] + '</div>';
          }

          row_after += '</div>';

          if (obj['manufacturer_url'] != '' && typeof(obj['manufacturer_url']) != "undefined" ) {
            row_after += '<div style="float:right;margin-right:14px;"><a href="' + obj['manufacturer_url'] + '">Find a Dealer</a></div>';
          }
          row_after += '</div>';
          items.push(["<img name='list_view_name_plus' src='" + accordionPlusGreyUrl + "' /> <div class='list-name'>" + name + "</div>", fuel_name, fuel_econ, compare, row_after]);
        });
        populate_model_years(json);
        populateFuels(json);
        populate_categories(json);
        populate_manufacturers();
        $('#num_vehicles').html(items.length);
        $("#vehicle_count").val(items.length);
        toggle_results_view();
        return items;
        // }
      },
      "beforeSend": function (xhr) {
        window.datatableAjax = xhr;
        $("#result_spinner").show();
        $("#list_table_wrapper").hide();
        $(".compare").hide();
      }
    },
    "oLanguage":{
      sInfo:"Showing _START_ to _END_ of _TOTAL_",
      sInfoFiltered:"",
      sZeroRecords:"No results to display",
      sLengthMenu: "Vehicles per page: _MENU_",
      sInfoEmpty:"0 results"
    },
    "iDisplayLength": display_length,
    "aoColumns": [
      { width: "400px", "class": 'vehicle-name' },
      { width: "200px" },
      { width: "200px", "sType": "numeric", "orderDataType": "mpg" },
      { width: "80px", "bSortable": false, 'class': 'compare_checkbox' },
      { width: 0, "bVisible": false}
    ],
    "sPaginationType":"bootstrap",
    "sDom": '<"top"<"clear">>rt<"bottom"pl<"clear">>',
    "bFilter": false,
    "bProcessing": false,
    "fnPreDrawCallback": function(){
      // colapse expanded rows
      $("tr.expanded").next().remove();
      $("tr.expanded").find('img').attr('src', accordionPlusGreyUrl);
      $("tr.expanded").removeClass('expanded');
    },
    "drawCallback": function() {
      // Add event listener for opening and closing details
      $('#list_table td').off('click');
      $('#list_table td').on('click', function(e) {
        if ($(e.target).is('input')) {
          return;
        }
        var row = $(this).parent();
        if (!row.hasClass('expanded')) {
          const oTable = $('#list_table').dataTable();
          var position = oTable.fnGetPosition(this); // getting the clicked row position
          var pRow = oTable.fnGetData(position[0]); // getting the values in the columns
          row.after('<tr class="detail_row"><td colspan="4" class="card_view_in_list">'+pRow[4]+'</td></tr>');
          row.addClass('expanded');
          row.addClass('highlighted_row');
          $(".lazy").each(function(){
            $(this).prop("src", $(this).attr('data-src'))
          });
          $(row).find('img').attr('src', accordionMinusGreyUrl);
        } else {
          row.removeClass('expanded');
          row.removeClass('highlighted_row');
          $(this).parent().next().remove();
          $(row).find('img').attr('src', accordionPlusGreyUrl);
        }
      });
      $('#list_table input[name="compare_ids[]"]').off('click');
      $('#list_table input[name="compare_ids[]"]').on('click', function() {
        if (compare_id_list.length >= MAX_NUMBER_COMPARE_LIST_ITEMS && $(this).prop('checked') == true) {
          alert('You may only select ' + MAX_NUMBER_COMPARE_LIST_ITEMS + ' vehicles to compare.');
          $(this).prop('checked', false);
        } else {
          if ($(this).prop('checked') == true) {
            compare_id_list.push($(this).val());
            $('#compare_block').css('display', 'block');
            $('#compare_block').css('height', 'auto');
            $('#compare_list').html($('#compare_list').html() + "<div class='item_box'>"+$(this).attr('data-name')+" <a href='javascript:window.remove_compare_item(\""+$(this).val()+"\");' id='close_"+$(this).val()+"' class='close_x'>X</a></div>");
          } else {
            window.remove_compare_item($(this).val());
          }
        }
      });
      window.calculate_vehicle_page_count();
      $("#result_spinner").hide();
      $('#list_table').css('width', '');
      $("#list_table_wrapper").show();
      $(".compare").show();
    }
  });

  window.pagination_client_side_load();
  window.pagination_update_per_page();

});

$.fn.dataTable.ext.order['mpg'] = function  ( settings, col )
{
  return this.api().column( col, {order:'index'} ).nodes().map( function(td) {
    var num = (isNaN(parseInt($.text(td)))) ? 0 : parseInt($.text(td));
    return num;
  } );
}

/* API method to get paging information */
$.fn.dataTableExt.oApi.fnPagingInfo = function ( oSettings )
{
  return {
    "iStart":         oSettings._iDisplayStart,
    "iEnd":           oSettings.fnDisplayEnd(),
    "iLength":        oSettings._iDisplayLength,
    "iTotal":         oSettings.fnRecordsTotal(),
    "iFilteredTotal": oSettings.fnRecordsDisplay(),
    "iPage":          Math.ceil( oSettings._iDisplayStart / oSettings._iDisplayLength ),
    "iTotalPages":    Math.ceil( oSettings.fnRecordsDisplay() / oSettings._iDisplayLength )
  };
}

$.fn.dataTableExt.oApi.fnReloadAjax = function ( oSettings, sNewSource, fnCallback, bStandingRedraw )
{
  if ( typeof sNewSource != 'undefined' && sNewSource != null )
  {
    oSettings.sAjaxSource = sNewSource;
  }
  this.oApi._fnProcessingDisplay( oSettings, true );
  var that = this;
  var iStart = oSettings._iDisplayStart;

  oSettings.fnServerData( oSettings.sAjaxSource, [], function(json) {
    /* Clear the old information from the table */
    that.oApi._fnClearTable( oSettings );

    /* Got the data - add it to the table */
    for ( var i=0 ; i<json.aaData.length ; i++ )
    {
      that.oApi._fnAddData( oSettings, json.aaData[i] );
    }

    oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
    that.fnDraw();

    if ( typeof bStandingRedraw != 'undefined' && bStandingRedraw === true )
    {
      oSettings._iDisplayStart = iStart;
      that.fnDraw( false );
    }

    that.oApi._fnProcessingDisplay( oSettings, false );

    /* Callback user function - for event handlers etc */
    if ( typeof fnCallback == 'function' && fnCallback != null )
    {
      fnCallback( oSettings );
    }
  }, oSettings );
}

/* Bootstrap style pagination control */
$.extend( $.fn.dataTableExt.oPagination, {
  "bootstrap": {
    "fnInit": function( oSettings, nPaging, fnDraw ) {
      var oLang = oSettings.oLanguage.oPaginate;
      var fnClickHandler = function ( e ) {
        e.defaultPrevented;
        if ( oSettings.oApi._fnPageChange(oSettings, e.data.action) ) {
          fnDraw( oSettings );
        }
      };

      $(nPaging).addClass('pagination').append(
        '<ul>' +
        '<li class="prev disabled"><a href="#">&larr; ' + oLang.sFirst + '</a></li>' +
        '<li class="prev disabled"><a href="#">&larr; '+oLang.sPrevious+'</a></li>'+
        '<li class="next disabled"><a href="#">' + oLang.sNext + ' &rarr; </a></li>' +
        '<li class="next disabled"><a href="#">' + oLang.sLast + ' &rarr; </a></li>' +
        '</ul>');
      var els = $('a', nPaging);
      $(els[0]).bind('click.DT', { action: "first" }, fnClickHandler);
      $(els[1]).bind('click.DT', { action: "previous" }, fnClickHandler );
      $(els[2]).bind('click.DT', { action: "next" }, fnClickHandler);
      $(els[3]).bind('click.DT', { action: "last" }, fnClickHandler);
    },

    "fnUpdate": function ( oSettings, fnDraw ) {
      var iListLength = 5;
      var oPaging = oSettings.oInstance.fnPagingInfo();
      var an = oSettings.aanFeatures.p;
      var j, sClass, iStart, iEnd, iHalf=Math.floor(iListLength/2);

      if ( oPaging.iTotalPages < iListLength) {
        iStart = 1;
        iEnd = oPaging.iTotalPages;
      }
      else if ( oPaging.iPage <= iHalf ) {
        iStart = 1;
        iEnd = iListLength;
      } else if ( oPaging.iPage >= (oPaging.iTotalPages-iHalf) ) {
        iStart = oPaging.iTotalPages - iListLength + 1;
        iEnd = oPaging.iTotalPages;
      } else {
        iStart = oPaging.iPage - iHalf + 1;
        iEnd = iStart + iListLength - 1;
      }

      for ( let i=0, iLen=an.length ; i<iLen ; i++ ) {
        // Remove the middle elements
        $('li:gt(1)', an[i]).filter(':not(.next)').remove();

        // Add the new list items and their event handlers
        for ( j=iStart ; j<=iEnd ; j++ ) {
          sClass = (j==oPaging.iPage+1) ? 'class="active"' : '';
          $('<li '+sClass+'><a href="#">'+j+'</a></li>')
            .insertBefore( $('li.next', an[i])[0] )
            .bind('click', function (e) {
              e.defaultPrevented;
              oSettings._iDisplayStart = (parseInt($('a', this).text(),10)-1) * oPaging.iLength;
              fnDraw( oSettings );
            } );
        }

        // Add / remove disabled classes from the static elements
        if ( oPaging.iPage === 0 ) {
          $('li.first, li.prev', an[i]).addClass('disabled');
        } else {
          $('li.first, li.prev', an[i]).removeClass('disabled');
        }

        if ( oPaging.iPage === oPaging.iTotalPages-1 || oPaging.iTotalPages === 0 ) {
          $('li.last, li.next', an[i]).addClass('disabled');
        } else {
          $('li.last, li.next', an[i]).removeClass('disabled');
        }
      }
    }
  }
} );
